import { Instance, SnapshotOut, types } from 'mobx-state-tree';

export const UserModel = types
  .model('User')
  .props({
    id: types.string,
    email: types.string,
    firstName: types.maybe(types.string),
    birthday: types.string,
    astrologicalSign: types.maybe(types.string),
    token: types.maybe(types.string),
    accessCode: types.maybe(types.string),
    paidSubscriber: types.boolean,
  })
  .actions((self) => ({
    setEmail: (value: string) => {
      self.email = value;
    },
  }));

type UserType = Instance<typeof UserModel>;

export interface User extends UserType {}

type UserSnapshotType = SnapshotOut<typeof UserModel>;

export interface UserSnapshot extends UserSnapshotType {}
